import React, { useState } from 'react';
import { SectionFade } from './ui/SectionFade';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Necesito conocimientos de nutrición?',
  a: 'Ninguno. Está escrito en lenguaje sencillo para gente con prisa.'
}, {
  q: '¿Sirve para cualquier país?',
  a: 'Sí, las tácticas de la industria son globales, especialmente en USA y Latinoamérica.'
}, {
  q: '¿Es un libro de recetas?',
  a: 'No, es un manual de defensa química y nutricional para que sepas qué comprar antes de cocinar.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-white text-brand-black" data-id="element-42">
      <div className="max-w-3xl mx-auto" data-id="element-43">
        <SectionFade data-id="element-44">
          <h2 className="font-bebas text-6xl md:text-8xl text-center mb-16 tracking-tight" data-id="element-45">
            PREGUNTAS{' '}
            <span className="text-brand-black bg-brand-neon px-4 inline-block transform -skew-x-6" data-id="element-46">
              FRECUENTES
            </span>
          </h2>
        </SectionFade>

        <div className="space-y-4" data-id="element-47">
          {faqs.map((faq, index) => <SectionFade key={index} delay={index * 0.1} data-id="element-48">
              <div className={`border-2 rounded-xl overflow-hidden transition-colors ${openIndex === index ? 'border-brand-black' : 'border-gray-200'}`} data-id="element-49">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left bg-white hover:bg-gray-50 transition-colors" data-id="element-50">
                  <span className="font-bebas text-2xl md:text-3xl tracking-wide" data-id="element-51">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`transform transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} size={24} data-id="element-52" />
                </button>

                <AnimatePresence data-id="element-53">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-54">
                      <div className="p-6 pt-0 text-gray-600 font-inter text-lg" data-id="element-55">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </SectionFade>)}
        </div>
      </div>
    </section>;
}